<template>
	<div class="etablishment-time">
        <span v-if="hour !== '0'" class="title">{{ hour }}</span>
        <span v-if="hour !== '0'" class="time">h</span>
        <span class="title">{{ minute }}</span>
        <span class="time">min</span>
    </div>
</template>

<script type="text/javascript">

    export default {
        name: 'etablishment-time',
        props : {
            hour : {
                type : String,
                default : ''
            },
            minute : {
                type : String,
                default : ''
            }
        }
    }

</script>

<style lang="scss">
    .etablishment-time {
        margin: -14px !important;
        .time {
            font-weight: none !important;
            color: $purple-alt;
            font-size: 40px !important;
        }
        .title {
            font-weight: 700;
        }
    }
</style>